import React, { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const SectionTitle: React.FC<Props> = ({ children }) => (
  <h2 className="text-[18px]/[24px] font-semibold text-foreground md:text-[24px]/[30px]">
    {children}
  </h2>
);
